// Add your custom JS here.
jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 50) {
        jQuery("header.header-site").addClass("scrolled");
    } else {
        jQuery("header.header-site").removeClass("scrolled");
    }
});

jQuery(document).ready(function ($) { });

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)"
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

//  Smooth scroll for hash links
document.addEventListener("DOMContentLoaded", function () {
    const isMobile = window.innerWidth < 992;
    const offset = isMobile ? 180 : 230;

    function scrollToHash(hash) {
        const el = document.querySelector(hash);
        if (el) {
            setTimeout(() => {
                window.scrollTo({
                    top:
                        el.getBoundingClientRect().top +
                        window.pageYOffset -
                        offset,
                    behavior: "smooth",
                });
            }, 50);
        }
    }

    if (window.location.hash) {
        scrollToHash(window.location.hash);
    }

    document.querySelectorAll('a[href^="#"]').forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = this.getAttribute("href");
            if (hash.length > 1) {
                e.preventDefault();
                history.pushState(null, null, hash);
                scrollToHash(hash);
            }
        });
    });
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Lenis Smooth Scroll
document.addEventListener("DOMContentLoaded", function () {
    // Initialize Lenis
    const lenis = new Lenis({
        autoRaf: true,
    });

    // Listen for the scroll event and log the event data
    lenis.on("scroll", (e) => {
        console.log(e);
    });
});

// Slider Logos

document.addEventListener("DOMContentLoaded", function () {
    const swiperLogos = new Swiper(".logo-slider", {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        hoverPause: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".logo-slider-next",
            prevEl: ".logo-slider-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            576: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 3, spaceBetween: 20 },
            992: { slidesPerView: 4, spaceBetween: 20 },
            1200: { slidesPerView: 6, spaceBetween: 30 },
        },
    });
});
// Slider cards
jQuery(document).ready(function ($) {
    var $slider = $(".cards-slider");
    var $title = $(".block-slider-block-cards-top-image-and-button__slider");
    var $controls = $(".slider-controls.mobile");
    var $wrapper = $(".container-arrows");

    if ($slider.length) {
        $slider.slick({
            slidesToShow: 3,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: true,
            dots: false,
            prevArrow: $(".btn-arrow-prev"),
            nextArrow: $(".btn-arrow-next"),
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 2 } },
                { breakpoint: 576, settings: { slidesToShow: 1 } },
            ],
        });

        if (typeof AOS !== "undefined") {
            AOS.refresh();
        }

        function checkSlides() {
            var slickInstance = $slider.slick("getSlick");
            var totalSlides = slickInstance.$slides.length;
            var currentSlidesToShow = slickInstance.options.slidesToShow;

            if (totalSlides <= currentSlidesToShow) {
                $title.addClass("few-items");
                $controls.addClass("no-slider-controls");
                $wrapper.addClass("few-items");
            } else {
                $title.removeClass("few-items");
                $controls.removeClass("no-slider-controls");
                $wrapper.removeClass("few-items");
            }
        }

        $slider.on("init setPosition", function () {
            checkSlides();
        });

        $(window).on("resize orientationchange", function () {
            setTimeout(checkSlides, 200);
        });

        if ($slider.hasClass("slick-initialized")) {
            checkSlides();
        }
    }
});

jQuery(document).ready(function ($) {
    $(".slider-animated-icons").each(function () {
        const $block = $(this);
        const $navContainer = $block.find(".slider-nav-icons");
        const $navItems = $navContainer.find(".nav-item");
        const $sliderMain = $block.find(".slider-main-content");

        if ($sliderMain.length) {
            if (typeof AOS !== "undefined") {
                $sliderMain.on("init", function () {
                    setTimeout(function () {
                        AOS.refresh();
                    }, 500);
                });
            }

            $sliderMain.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 3000,
                prevArrow:
                    '<button type="button" class="slick-prev custom-arrow"></button>',
                nextArrow:
                    '<button type="button" class="slick-next custom-arrow"></button>',
            });

            $navItems.on("click", function () {
                const index = $(this).index();
                $sliderMain.slick("slickGoTo", index);
            });

            $sliderMain.on(
                "beforeChange",
                function (event, slick, currentSlide, nextSlide) {
                    $navItems.removeClass("active");

                    $navItems.removeClass("animate-beam");
                    if (nextSlide > currentSlide) {
                        for (let i = currentSlide; i < nextSlide; i++) {
                            $navItems.eq(i).addClass("animate-beam");
                        }
                    }

                    $navItems.eq(nextSlide).addClass("active");

                    if ($(window).width() <= 1300) {
                        const $nextItem = $navItems.eq(nextSlide);
                        if ($nextItem.length) {
                            const containerWidth = $navContainer.width();
                            const itemLeft = $nextItem[0].offsetLeft;
                            const itemWidth = $nextItem.outerWidth();
                            const scrollPosition =
                                itemLeft - containerWidth / 2 + itemWidth / 2;

                            $navContainer.animate(
                                { scrollLeft: scrollPosition },
                                300
                            );
                        }
                    }
                }
            );

            $navItems.first().addClass("active");
        }
    });
});

// Slider Cards Top Image
jQuery(document).ready(function ($) {
    $(".slider-cards-top-image__slider").each(function () {
        const $slider = $(this);
        const $wrapper = $slider.closest(
            ".slider-cards-top-image__slider-wrapper"
        );
        const $prevArrow = $wrapper.find(".slick-prev");
        const $nextArrow = $wrapper.find(".slick-next");

        if (typeof AOS !== "undefined") {
            $slider.on("init", function () {
                setTimeout(function () {
                    AOS.refresh();
                }, 500);
            });
        }

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            infinite: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });
});
//slider-latest
jQuery(document).ready(function ($) {
    $(".latest-insights").each(function () {
        const $block = $(this);
        const $slider = $block.find(".insights-list");
        const $prevArrow = $block.find(".slider-tabs__prev");
        const $nextArrow = $block.find(".slider-tabs__next");

        function initOrDestroy() {
            const shouldBeSlider = window.innerWidth <= 1023;

            if (shouldBeSlider) {
                if (!$slider.hasClass("slick-initialized")) {
                    $slider.slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        dots: false,
                        prevArrow: $prevArrow,
                        nextArrow: $nextArrow,
                        infinite: true,
                        speed: 450,
                        cssEase: "ease-in-out",
                        responsive: [
                            { breakpoint: 768, settings: { slidesToShow: 1 } },
                        ],
                    });
                }
            } else {
                if ($slider.hasClass("slick-initialized")) {
                    $slider.slick("unslick");
                }
            }
        }

        initOrDestroy();
        $(window).on("resize orientationchange", initOrDestroy);
    });
});
//vertical
jQuery(document).ready(function ($) {
    $(".tabs-vertical-side-card").each(function () {
        const $block = $(this);
        const $tabs = $block.find(".tabs-vertical-side-card__item");
        const $buttons = $block.find(".tabs-vertical-side-card__menu li");
        const $counter = $block.find("#tabs-current");
        const $wrapper = $block.find(".tabs-vertical-side-card__wrapper");
        const $prevArrow = $block.find(".slider-tabs__prev");
        const $nextArrow = $block.find(".slider-tabs__next");
        function activateTab(id) {
            $tabs.removeClass("active");
            $tabs.filter(`#${id}`).addClass("active");
            $buttons.removeClass("active");
            $buttons.filter(`[data-filter="#${id}"]`).addClass("active");
            if ($(window).width() >= 991 && typeof AOS !== "undefined") {
                AOS.refresh();
            }
        }
        $buttons.on("click", function (e) {
            e.preventDefault();
            const id = $(this).data("filter").substring(1);
            activateTab(id);
        });
        $buttons.on("keydown", function (e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                const id = $(this).data("filter").substring(1);
                activateTab(id);
            }
        });

        function initSlider() {
            if ($(window).width() < 991) {
                if (!$wrapper.hasClass("slick-initialized")) {
                    $wrapper.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        prevArrow: $prevArrow,
                        nextArrow: $nextArrow,
                        adaptiveHeight: true,
                    });
                    $wrapper.on(
                        "afterChange",
                        function (event, slick, currentSlide) {
                            const tabId = $tabs.eq(currentSlide).attr("id");
                            activateTab(tabId);
                            if ($counter.length) {
                                $counter.text(
                                    ("0" + (currentSlide + 1)).slice(-2)
                                );
                            }
                        }
                    );
                }
            } else {
                if ($wrapper.hasClass("slick-initialized")) {
                    $wrapper.slick("unslick");
                }
            }
        }
        initSlider();
        $(window).on("resize orientationchange", function () {
            initSlider();
        });
    });
});

// Timeline Block Swiper
document.addEventListener("DOMContentLoaded", function () {
    const timelineBlocks = document.querySelectorAll(".timeline-wrapper");
    timelineBlocks.forEach((wrapper) => {
        const thumbsSlider = wrapper.querySelector(".timeline-thumbs");
        const mainSlider = wrapper.querySelector(".timeline-main");
        const nextBtn = wrapper.querySelector(".timeline-next");
        const prevBtn = wrapper.querySelector(".timeline-prev");

        if (thumbsSlider && mainSlider) {
            const swiperThumbs = new Swiper(thumbsSlider, {
                spaceBetween: 0,
                slidesPerView: 3,
                watchSlidesProgress: true,
                centeredSlides: false,
                slideToClickedSlide: true,
                loop: false,
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                breakpoints: {
                    320: { slidesPerView: 3 },
                    768: { slidesPerView: 5 },
                    1024: { slidesPerView: 6 },
                },
            });

            const swiperMain = new Swiper(mainSlider, {
                spaceBetween: 20,
                allowTouchMove: false,
                effect: "fade",
                fadeEffect: { crossFade: true },
                thumbs: {
                    swiper: swiperThumbs,
                },
            });
        }
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const SITE_HEADER_SELECTOR = 'header';
    const EXTRA_OFFSET = 100;

    const siteHeader = document.querySelector(SITE_HEADER_SELECTOR);
    const siteHeaderHeight = siteHeader ? siteHeader.offsetHeight : 0;

    document.querySelectorAll('.accordion-collapse').forEach(collapse => {
        collapse.addEventListener('shown.bs.collapse', () => {
            requestAnimationFrame(() => {
                setTimeout(() => {
                    const accordionItem = collapse.closest('.accordion-item');
                    const accordionHeader = accordionItem.querySelector('.accordion-header');

                    const headerTop =
                        accordionHeader.getBoundingClientRect().top +
                        window.pageYOffset;

                    const targetScroll =
                        headerTop - siteHeaderHeight - EXTRA_OFFSET;

                    window.scrollTo({
                        top: Math.max(targetScroll, 0),
                        behavior: 'smooth'
                    });
                }, 100);
            });
        });
    });
});
//grid cards
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".qa-cards-grid").forEach((grid) => {
    const cards = Array.from(grid.querySelectorAll("a.qa-card"));
    if (cards.length >= 2 && cards.length % 3 === 2) {
      const wrap = document.createElement("div");
      wrap.className = "qa-last-two-wrap";

      // mueve los últimos 2 dentro del wrap
      wrap.appendChild(cards[cards.length - 2]);
      wrap.appendChild(cards[cards.length - 1]);

      grid.appendChild(wrap);
    }
  });
});